import React from "react";
import Navbar from "../Layout/Navbar";
import {Typography, Col, Row, Collapse} from "antd";
import {compose} from "redux";
import {firestoreConnect} from "react-redux-firebase";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import {  } from 'antd';
const { Panel } = Collapse;


const text = (
    <p style={{ paddingLeft: 24 }}>
        A dog is a type of domesticated animal. Known for its loyalty and faithfulness, it can be found
        as a welcome guest in many households across the world.
    </p>
);


class Shops extends React.Component {

    state = {
        search: null
    }

    getRating = (shop) => {
        if(shop.rating){
            let sum = shop.rating.one + shop.rating.two*2 + shop.rating.three*3 + shop.rating.four*4 + shop.rating.five*5;
            let count = shop.rating.one + shop.rating.two + shop.rating.three + shop.rating.four + shop.rating.five;
            return (
                <div>
                    <span className="fas fa-star color-yellow" /> {count  > 0 ? sum/count : "Not enough"}
                </div>
            );
        } else {
            return (
                <div>
                    <span className="fas fa-star color-yellow" /> Not enough
                </div>
            )
        }
    }


    onSearch = e => {
        this.setState({
            search: e.target.value.length > 0 ? e.target.value.toLowerCase() : null
        })
    }

    render() {
        const { shops } = this.props;
        const { search } = this.state;
        let tempShops = shops;
        if(search){
            tempShops = shops.filter(shop => shop.title.toLowerCase().includes(search));
        }

        return (
            <div>
                <div>
                    <div className="uk-container">
                        <div className="uk-margin-top uk-margin-bottom">
                            <div className="uk-text-center">
                                <h3 className="uk-h2 uk-margin-small-bottom uk-text-bold">
                                    Shops
                                </h3>
                                <p className="uk-h4 uk-margin-remove-top uk-margin-bottom uk-container uk-container-small">
                                    Every classroom is different. Apple Field Trips can be, too. Teachers can tailor their trip to complement the education that students are getting in their classrooms
                                </p>
                            </div>
                        </div>
                        <nav className="uk-navbar-container" uk-navbar="true">
                            <div className="uk-navbar-left">

                                <div className="uk-navbar-item">
                                    <form className="uk-search uk-search-navbar">
                                        <span uk-search-icon="true" />
                                        <input onChange={this.onSearch} className="uk-search-input" type="search" placeholder="Search..."    />
                                    </form>
                                </div>

                            </div>
                        </nav>

                        <div className="uk-margin-top uk-margin-large-bottom">
                            <div className="uk-grid-match uk-grid-small uk-child-width-1-1@s uk-child-width-1-3@m" uk-grid="true">
                                { tempShops.map(shop => (
                                    <div>
                                        <div className="uk-card uk-card-default">
                                            <div className="uk-card-media-top">
                                                <img className="uk-height-medium" src={shop.background} alt=""  />
                                            </div>
                                            <div className="uk-card-body uk-padding-small">
                                                <div className="uk-grid-small uk-flex-middle uk-margin-small-bottom" uk-grid="true">
                                                    <div className="uk-width-auto">
                                                        <img className="uk-border-circle" width="40" height="40"
                                                             src={shop.logo} />
                                                    </div>
                                                    <div className="uk-width-expand">
                                                        <h3 className="uk-card-title uk-margin-remove-bottom">
                                                            <Link className="uk-link-heading" to={"shops/" + shop.id}>
                                                                {shop.title}
                                                            </Link>
                                                        </h3>
                                                        <p className="uk-text-meta uk-margin-remove-top">
                                                            <time>
                                                                { this.getRating(shop) }
                                                            </time>
                                                        </p>
                                                    </div>
                                                </div>
                                                <Typography.Paragraph>
                                                    { shop.about.substring(0, 200) }
                                                </Typography.Paragraph>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



const mapStateToProps = (state) => {

    return {
        auth: state.firebase.auth,
        shops: state.firestore.ordered.shops ? state.firestore.ordered.shops : []
    }
}

const enhance = compose(
    firestoreConnect([
        { collection: "shops" }
    ]),
    connect(mapStateToProps)
);
export default enhance(Shops);



// WEBPACK FOOTER //
// ./src/Components/Shop/index.js